import { useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { breadcrumbsHeaderState, useSettingsLinkItems } from 'shared/components';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { Path } from 'urlBuilder';

export const useContactPaymentDetailsBreadcrumbs = () => {
    const setBreadcrumbs = useSetAtom(breadcrumbsHeaderState);
    const company = useCompanyBasedOnUrl();
    const settingsLinkItems = useSettingsLinkItems(company)[0];

    const location = useLocation();

    const breadcrumbs = useMemo(() => {
        const currentItem = settingsLinkItems.subItems.find(({ id }) => id === Path.contactPaymentDetails);

        return [
            {
                name: settingsLinkItems.name,
                to: currentItem?.to,
            },
            {
                value: currentItem?.to + location.search,
                subItems: settingsLinkItems.subItems
                    .filter(({ available }) => available ?? true)
                    .map((subItem) => {
                        if (subItem.id === Path.contactPaymentDetails) {
                            return {
                                ...subItem,
                                to: subItem.to + location.search,
                            };
                        }

                        return subItem;
                    }),
            },
        ];
    }, [settingsLinkItems.name, settingsLinkItems.subItems, location]);

    useEffect(() => {
        setBreadcrumbs(breadcrumbs);
    }, [breadcrumbs, setBreadcrumbs]);
};
